import React, { useCallback } from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useCustomTheme } from 'contexts';

export const ThemeToggle = () => {
    const theme = useCustomTheme();
    const isDark = theme.palette.mode === 'dark';

    const toggle = useCallback(() => {
        theme.setThemeMode(isDark ? 'light' : 'dark');
    }, [theme, isDark]);

    return (
        <Tooltip title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}>
            <IconButton onClick={toggle} color="inherit" aria-label="toggle theme">
                {isDark ? <Brightness7Icon /> : <Brightness4Icon />}
            </IconButton>
        </Tooltip>
    );
};
